import queryString from 'query-string'
import { paymentGatewayHosts } from 'consts'

export const buildPaymentRedirectUrl = (
  paymentUrl: string,
  params: Record<string, string | number>
): string | null => {
  const redirectUrl = `${paymentUrl}?${queryString.stringify(params)}`

  let url: URL
  try {
    url = new URL(redirectUrl)
  } catch {
    return null
  }

  if (
    url.protocol !== 'https:' ||
    !!url.username ||
    !!url.password ||
    !paymentGatewayHosts.includes(url.hostname)
  ) {
    return null
  }

  return redirectUrl
}
